import { FunctionComponent } from 'react';
import { Div, Icon, SupportedIconName } from '@gaiads/telia-react-component-library';

export const IconWithBackgroundColor: FunctionComponent<SupportedIconName> = iconName => {
  return (
    <Div
      alignTextToCenter
      backgroundColor={'purple100'}
      borderRadius={{ size: 'rounded' }}
      style={{ width: '42px', height: '42px' }}
      padding={{ top: 'xs' }}
    >
      <Icon name={iconName} size={'md'} />
    </Div>
  );
};
